exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-loader[data-v-549973fd]{width:16px;height:16px}", ""]);

// exports
